
  <!--
  <h1 mat-dialog-title>{{module_number}} / {{module_total}}</h1>
  -->
  <div class="modal-body" mat-dialog-content>
    
    <div [ngSwitch]="module_number">
      
      <div *ngSwitchCase = "1">
        <stepper-module-1 #StepperModule1 (change) = "nextModule($event)"></stepper-module-1> 
      </div>
      
      <div *ngSwitchCase = "2">
        <stepper-module-2 #StepperModule2 [orgId] = "orgId" (change) = "nextModule($event)"></stepper-module-2> 
      </div>

      <div *ngSwitchCase = "3">
        <stepper-module-3 #StepperModule3 (change) = "nextModule($event)"></stepper-module-3> 
      </div>
      
    </div>
    
  </div>
  <div class="modal-footer" mat-dialog-actions translate>

    <!--     
    <button mat-icon-button>
      <mat-icon matTooltip="Info  }}">help</mat-icon>  
    </button> -->

    <ng-container>
        <button mat-icon-button (click) = "cancel()">
          <mat-icon matTooltip="{{ 'stepper.tooltip.cancel' | translate }}">cancel</mat-icon>  
        </button>  
    </ng-container>

    <ng-container *ngIf="canGoBack()">
      <button mat-icon-button (click) = "previousModule()">
        <mat-icon matTooltip="{{ 'stepper.tooltip.previous' | translate }}">chevron_left</mat-icon>  
      </button>
    </ng-container>    
      
    <ng-container *ngIf="module_number != module_total">
      <button mat-icon-button (click) = "sayNextModule()">
        <mat-icon matTooltip="{{ 'stepper.tooltip.next' | translate }}">chevron_right</mat-icon>
      </button>  
    </ng-container>

    <ng-container *ngIf="module_number == module_total">
      <button mat-icon-button (click) = "sayNextModule()">
        <mat-icon matTooltip="{{ 'stepper.tooltip.continue' | translate }}">check_circle</mat-icon>
      </button>  
    </ng-container>
    
  </div>